// extracted by mini-css-extract-plugin
export default {"container":"L4UYN","light":"DQMT0","telegram":"IN7rH","twitter":"bonSW","facebook":"dmpM6","whatsapp":"FWMym","linkedin":"m_hIC"};